module.exports = __webpack_public_path__ + "static/media/indigo-tail.cbced4fb.png";